import { useState } from "react";
import { Play } from "lucide-react";
import { getVideoEmbed } from "@/components/SectionBlocks";

function ytThumb(url) {
  const m = (url || "").match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  return m ? `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` : null;
}

export function VideoThumb({ url, poster, className = "" }) {
  const [play, setPlay] = useState(false);
  const embed = getVideoEmbed(url);
  if (!embed) return null;
  const thumb = ytThumb(url) || poster || null;

  if (play) {
    return (
      <figure className={`rounded-xl overflow-hidden border border-white/10 ${className}`} data-testid="video-player">
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          {embed.type === "iframe" ? (
            <iframe title="Video" src={`${embed.src}?autoplay=1`} className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          ) : (
            <video src={embed.src} controls autoPlay className="absolute inset-0 w-full h-full bg-black" />
          )}
        </div>
      </figure>
    );
  }

  return (
    <button type="button" data-testid="video-thumb" onClick={() => setPlay(true)} aria-label="Riproduci video"
      className={`group relative block w-full rounded-xl overflow-hidden border border-white/10 ${className}`}>
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        {thumb ? (
          <img src={thumb} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-[#1E293B] to-[#020617]" />
        )}
        <div className="absolute inset-0 bg-black/30 group-hover:bg-black/15 transition-colors flex items-center justify-center">
          <span className="w-16 h-16 rounded-full bg-gold/90 text-[#020617] flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
            <Play className="w-7 h-7 ml-1" fill="currentColor" />
          </span>
        </div>
      </div>
    </button>
  );
}
